import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";
import { printDate, printLocation } from "../../../utils/helper";
import React, { useState, useEffect } from "react";
import { customer, user, user as userAPI } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { useQuery } from "@tanstack/react-query";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import ModalChangeUser from "./modal/changeUsers";
import AddMultipleUsers from "./modal/addMultipleUsers";
import { useDashboardContext } from "../../../contexts/NewDashboardContext";

import ConfirmationDlg from "../../../components/ConfirmationDlg";
import { PermissionChecker } from "../../../components/PermissionChecker";
import { useAuth } from "../../../contexts/AuthContext";
import DebounceInput from "../../../components/form/HorizontalDebounceInput";
import ModalOTP from "./modal/modalOTP";
import { downloadExcel } from "../../../utils/exporter";

function UserConfiguration() {
  const [openOTP, setOpenOTP] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [openMultipleUsers, setOpenMultipleUsers] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [confirmDlg, setConfirmDlg] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const { addSetupDone, selectedApp } = useDashboardContext();
  const [query, setQuery] = useState({
    page: 1,
    take: 10,
    totalData: 1,
    search: "",
  });

  const [users, setUsers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);
  const { username } = useAuth();

  async function getCustomer() {
    const res = await customer.list();
    if (res.ok) {
      const body = await res.json();
      let data = body.data;
      setCustomers(data)
    }
  }
  const handleChangeKeyword = (e) => {
    setQuery((prev) => ({
      ...prev,
      page: 1,
      search: e.target.value,
    }));
  };
  const onConfirmOTP = () => {
    setOpenOTP(false);
    const payload = {
      username: selectedRow.username,
      number: selectedRow.phone,
    }
    userAPI.verifyWhatsapp(payload).then((res) => {
      if (res.ok) {
        const body = res.json();
        toast.success("OTP sent successfully");
      }
    })
  };

  const onOpenOTP = (row) => {
    setOpenOTP(true);
    setSelectedRow(row);
  };

  async function getUser() {
    try {
      setLoading(true);
      const res = await userAPI.list(query);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          let tmp = [];
          data.results.map((i, index) => {
            let item = i;
            item.id = index + 1;
            tmp.push(item);
          });
          setUsers(tmp);

          if (data.totalData) {
            setQuery((prev) => ({
              ...prev,
              totalData: data.totalData,
            }));
          }

          setIsDirty(false);
        }
        setLoading(false);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    console.log({ query })
    getUser();
  }, [query.page, query.take, isDirty, query.search]);
  useEffect(() => {
    getCustomer();
  }, []);

  function selectUser(value) {
    //console.log("selected machine", value);
  }
  function addUser(value) {
    setOpenDetail(true);
  }
  function editUser(value) {
    setSelectedRow(value);
    setOpenDetail(true);
  }

  function showConfirmationDlg(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }
  function hideConfirmationDialog() {
    setDeleteRow(null);
    setConfirmDlg(false);
  }

  async function exportUsers() {
    try {
      setLoadingExport(true);
      const newQuery = { search: query.search };

      const res = await userAPI.list(newQuery);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        let users = data.map((user) => {
          return {
            email: user.email,
            name: user.firstname + " " + user.lastname,
            role: user.companies[0].cmms_role?.name,
            customer: user.customer?.customer_name,
          };
        });

        downloadExcel(users, "users");

        setLoadingExport(false);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  async function deleteUser() {
    try {
      const res = await userAPI.delete(deleteRow.username);
      if (res.ok) {
        toast.success("This user has been deleted");
        setConfirmDlg(false);
        setDeleteRow(null);
        const body = await res.json();
        setIsDirty(true);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  const columns = [
    {
      name: "Email",
      selector: (row) => row.email,
    },
    {
      name: "Name",
      minWidth: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <span>
            {row.firstname} {row.lastname}
          </span>
        );
      },
    },
    {
      name: "Role",
      selector: (row) =>
        selectedApp == "CMMS"
          ? row.companies[0].cmms_role?.name
          : row.companies[0].role?.rolename,
    },
    {
      name: "customer",
      selector: (row) => row.customer?.customer_name
    },
    {
      name: "Whatsapp Validated",
      selector: (row) => row.whatsapp_id,
      cell: (row) => {
        return (
          <>
            <div className="flex items-center">
              {row.whatsapp_id ? (
                <span className="text-green-500">✅</span>
              ) : (
                <>
                  <span className="text-red-500">❌</span>
                </>
              )}
            </div>
          </>
        );
      },
    },
    {
      name: "Action",
      width: "250px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <div>
            {row.whatsapp_id ? (
              <span className="text-green-500"></span>
            ) : (
              <>
                <button onClick={() => onOpenOTP(row)} className="btn btn-sm btn-outline-theme mx-1">
                  <i className="fa fa-check"></i> Verify Whatsapp
                </button>
              </>
            )}
            <button
              onClick={() => {
                editUser(row);
              }}
              className="btn btn-sm btn-outline-theme mx-1"
            >
              <i className="fa fa-edit"></i>
            </button>

            <PermissionChecker permissions={["delete people"]} hideIfNotAllowed>
              <button
                onClick={() => {
                  showConfirmationDlg(row);
                }}
                className="btn btn-sm btn-outline-danger"
              >
                <i className="fa fa-trash"></i>
              </button>
            </PermissionChecker>
          </div>
        );
      },
    },
  ];
  async function onSubmit({
    password,
    email,
    jobTitle,
    firstname,
    lastname,
    customer_id,
    trimmedDataURL,
    contactNumber,
    phone,
    userRole,
    status,
    locations,
    assets,
  }) {
    let data = {
      password,
      email,
      customer_id,
      job_title: jobTitle,
      firstname,
      lastname,
      signatureB64: trimmedDataURL,
      phone: String(phone),
      //contact_number: contactNumber,
      role_id: userRole,
      //is_active: status == 1 ? true : false,
      is_staff: false,
      app: selectedApp,
      locations,
      assets,
    };

    if (!selectedRow) {
      const response = await userAPI.create(data);
      const body = await response.json();
      if (response.ok) {
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("New user is successfully added");
          setSelectedRow(null);
          setOpenDetail(false);
          setIsDirty(true);
          setQuery((prev) => ({
            ...prev,
            page: 1,
            search: "",
          }));
          await addSetupDone({ user_setup_center: "team" });
        } else {
          toast.error(body.message);
        }
      } else {
        if (response.status == 409) {
          toast.error(body.message);
        } else {
          toast.error("Something went wrong");
        }
      }
    } else {
      const response = await userAPI.update(selectedRow.username, data);
      const body = await response.json();
      if (response.ok) {
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("User is successfully updated");
          setSelectedRow(null);
          setOpenDetail(false);
          setIsDirty(true);
          setQuery((prev) => ({
            ...prev,
            page: 1,
            search: "",
          }));
        } else {
          toast.error(body.message);
        }
      } else {
        if (response.status == 409) {
          toast.error(body.message);
        } else {
          toast.error("Something went wrong");
        }
      }
    }
  }

  return (
    <div>
      <ModalOTP
        open={openOTP}
        onClose={() => setOpenOTP(false)}
        onConfirm={onConfirmOTP}
        data={selectedRow}
      />
      <ModalChangeUser
        customers={customers}
        onSubmit={onSubmit}
        open={openDetail}
        row={selectedRow}
        onClose={() => {
          setSelectedRow(null);
          setOpenDetail(false);
        }}
      ></ModalChangeUser>
      <AddMultipleUsers
        customers={customers}
        open={openMultipleUsers}
        onClose={() => setOpenMultipleUsers(false)}
        onSuccess={() => {
          setIsDirty(true);
          setOpenMultipleUsers(false);
        }}
      />
      <ConfirmationDlg
        open={confirmDlg}
        onClose={() => {
          setConfirmDlg(false);
          setDeleteRow(null);
        }}
        onSubmit={deleteUser}
      >
        <div>Are you sure you want to delete this User?</div>
      </ConfirmationDlg>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Configuration</a>
            </li>
            <li className="breadcrumb-item active">Users</li>
          </ol>
          <h1 className="page-header mb-0">Users</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-12 ">
          <div className="row justify-content-end">
            <div className="col-sm-3 mb-2 mb-sm-0">
              <DebounceInput
                name="keyword2"
                value={query.search}
                placeholder={"Search User / customer"}
                showDebounceIndicator
                delay={1000}
                onchange={handleChangeKeyword}
              />
            </div>
            <div className="col-sm-2 mb-2 mb-sm-0">
              <PermissionChecker
                permissions={["create people"]}
                hideIfNotAllowed
              >
                <button
                  onClick={addUser}
                  className="btn btn-outline-theme w-100"
                >
                  Add User <i className="bi bi-plus"></i>
                </button>
              </PermissionChecker>
            </div>
            <div className="col-sm-2 mb-2 mb-sm-0 ms-2">
              <PermissionChecker
                permissions={["create people"]}
                hideIfNotAllowed
              >
                <button
                  onClick={() => setOpenMultipleUsers(true)}
                  className="btn btn-outline-theme w-100"
                >
                  Add Multiple Users <i className="bi bi-people"></i>
                </button>
              </PermissionChecker>
            </div>
            <div className="col-sm-2 mb-2 mb-sm-0 ms-2">
              <PermissionChecker
                permissions={["create people"]}
                hideIfNotAllowed
              >
                <button
                  onClick={() => exportUsers()}
                  className="btn btn-outline-theme w-100"
                >
                  Export Users <i className="bi bi-file-earmark-excel"></i>
                </button>
              </PermissionChecker>
            </div>
          </div>
          <Card className="mb-4 mt-2">
            <CardHeader>Update User Profile</CardHeader>
            <CardBody>
              <DataTable
                progressPending={loading}
                pointerOnHover
                onRowClicked={(row) => {
                  editUser(row);
                }}
                highlightOnHover
                theme="dark"
                columns={columns}
                data={users}
                pagination
                paginationServer
                paginationDefaultPage={query.page}
                onChangeRowsPerPage={(row) =>
                  setQuery((prev) => ({ ...prev, page: 1, take: row }))
                }
                paginationTotalRows={query.totalData}
                onChangePage={(page) =>
                  setQuery((prev) => ({ ...prev, page: page }))
                }
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default UserConfiguration;
